import ActionTypes from "../constants/action-types";
import store from "../reducers/reducer";

export const setVideoPlayerIsPlaying = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_VIDEO_PLAYER_IS_PLAYING,
        payload
    });
};

export const setVideoPlayerId = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_VIDEO_PLAYER_ID,
        payload
    });
};

export const setVideoPlayerSource = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_VIDEO_PLAYER_SOURCE,
        payload
    });
};
